// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/css/emails.css
// module id = 636
// module chunks = 1